/**
 * Oude paden (portaal v1 op /oud en de paden van vóór sessie 45) sturen
 * sinds sessie 67 netjes door naar de werkplek. Alleen /werkplek/<pad>
 * behoudt zijn pad zonder voorvoegsel (/werkplek/klanten/1 wordt
 * /klanten/1); de rest landt op Vandaag. De server doet hetzelfde met een
 * 302 (`app/main.py`, `_oud_pad_naar`); dit vangt de navigatie binnen de app.
 */
export function oudPadNaar(pathname: string, search = ""): string {
  if (pathname === "/werkplek" || pathname.startsWith("/werkplek/")) {
    // Nooit "//host": dat leest de browser als een andere site.
    const rest = "/" + pathname.slice("/werkplek".length).replace(/^\/+/, "");
    return `${rest}${search}`;
  }
  // Diepe links uit oude mails en meldingen: naar hetzelfde gesprek.
  const pad = pathname.replace(/^\/oud(?=\/)/, "");
  const chat = pad.match(/^\/admin\/(?:chat|whatsapp)\/([0-9a-f-]{36})$/i);
  if (chat) return `/?chat=${chat[1]}`;
  const mail = pad.match(/^\/emails?\/([0-9a-f-]{36})$/i);
  if (mail) return `/?mail=${mail[1]}`;
  if (pad === "/profiel") return "/profiel/beveiliging";
  return "/";
}
